import type {
  AIModel,
  AIModelSuggestResponse,
  DataResponse,
  ModelReferences,
  ModelTierDefault,
  ModelTierDefaultsResponse,
  PaginatedResponse,
} from "@/types";
import { api } from "../api";

export const modelService = {
  list: () => api.get<PaginatedResponse<AIModel>>("/models"),
  adminList: () => api.get<PaginatedResponse<AIModel>>("/admin/models"),
  get: (modelId: string) => api.get<DataResponse<AIModel>>(`/models/${modelId}`),
  create: (data: Partial<AIModel>) => api.post<DataResponse<AIModel>>("/admin/models", data),
  update: (modelId: string, data: Partial<AIModel>) =>
    api.patch<DataResponse<AIModel>>(`/admin/models/${modelId}`, data),
  delete: (modelId: string) => api.delete<DataResponse<unknown>>(`/admin/models/${modelId}`),
  getReferences: (modelId: string) => api.get<DataResponse<ModelReferences>>(`/admin/models/${modelId}/references`),
  reassign: (modelId: string, replacementModelId: string) =>
    api.post<{ message: string }>(`/admin/models/${modelId}/reassign`, { replacement_model_id: replacementModelId }),
  suggest: (modelName: string) =>
    api.post<DataResponse<AIModelSuggestResponse>>("/admin/models/suggest", { modelName }),

  // Tier defaults
  listUserFacingTierDefaults: () =>
    api.get<DataResponse<ModelTierDefaultsResponse>>("/models/tier-defaults/user-facing"),
  listAllTierDefaults: () => api.get<DataResponse<ModelTierDefaultsResponse>>("/admin/models/tier-defaults"),
  updateTierDefault: (tier: string, modelId: string | null) =>
    api.put<DataResponse<ModelTierDefault>>(`/admin/models/tier-defaults/${tier}`, { model_id: modelId }),
};
